type ENVIRONMENTS = 'local' | 'staging' | 'production' | 'simulation' | 'dev' | 'test';

export function getEnvironnementFromUrl(url: string): ENVIRONMENTS {
  if (import.meta.env.VITE_SIMULATION) {
    return 'simulation';
  }
  if (url.includes('dev.app.')) return 'dev';
  if (url.includes('staging.app.')) return 'staging';
  if (url.includes('test.app.')) return 'test';
  if (url.includes('https://app.livelinx.com')) return 'production';

  return 'local';
}
